import {
  LayoutDashboard,
  Radio,
  MessageSquare,
  Brain,
  Activity,
  Users,
  Award,
  UserCheck,
  Heart,
  Megaphone,
  Shield,
  AlertTriangle,
  ListTodo,
  Target,
  Gift,
  Mail,
  Sparkles,
  Coffee,
  MonitorSmartphone,
  TrendingUp,
  Briefcase,
  Scale,
  UserCog,
  Handshake,
  RefreshCw,
  Headphones,
  ClipboardCheck,
  BarChart3,
  GitBranch,
  Flame,
  TrendingDown,
  Link2,
  Bot,
  LineChart,
  Telescope,
  Crown,
} from 'lucide-react';

export const getEmployeeSatisfactionEngagementNavChildren = () => [
  {
    label: 'Employee Voice, Sentiment & Experience Monitoring',
    icon: Radio,
    path: '/employee-satisfaction-engagement/dashboard',
    children: [
      { path: '/employee-satisfaction-engagement/dashboard', label: 'Engagement Dashboard', icon: LayoutDashboard },
      { path: '/employee-satisfaction-engagement/pulse-surveys', label: 'Pulse Surveys', icon: Activity },
      { path: '/employee-satisfaction-engagement/feedback', label: 'Employee Feedback', icon: MessageSquare },
      { path: '/employee-satisfaction-engagement/sentiment', label: 'Sentiment Intelligence', icon: Brain },
      { path: '/employee-satisfaction-engagement/experience-monitoring', label: 'Employee Experience Monitoring', icon: MonitorSmartphone },
      { path: '/employee-satisfaction-engagement/team-climate', label: 'Team Climate & Collaboration', icon: Users },
      { path: '/employee-satisfaction-engagement/recognition-visibility', label: 'Recognition & Appreciation Visibility', icon: Award },
      { path: '/employee-satisfaction-engagement/manager-connect', label: 'Manager Connect & Check-ins', icon: UserCheck },
      { path: '/employee-satisfaction-engagement/wellbeing-worklife', label: 'Wellbeing & Work-Life Experience', icon: Heart },
      { path: '/employee-satisfaction-engagement/communication-transparency', label: 'Communication & Transparency Experience', icon: Megaphone },
      { path: '/employee-satisfaction-engagement/inclusion-belonging', label: 'Inclusion, Fairness & Belonging', icon: Shield },
      { path: '/employee-satisfaction-engagement/grievance-concerns', label: 'Grievances, Concerns & Workplace Issues', icon: AlertTriangle },
    ],
  },
  {
    label: 'Engagement Programs, Manager Actions & Experience Improvement',
    icon: ListTodo,
    path: '/employee-satisfaction-engagement/action-planning',
    children: [
      { path: '/employee-satisfaction-engagement/action-planning', label: 'Engagement Action Planning', icon: Target },
      { path: '/employee-satisfaction-engagement/manager-interventions', label: 'Manager-led Interventions', icon: UserCog },
      { path: '/employee-satisfaction-engagement/recognition-programs', label: 'Recognition & Rewards Programs', icon: Gift },
      { path: '/employee-satisfaction-engagement/communication-campaigns', label: 'Communication & Campaign Management', icon: Mail },
      { path: '/employee-satisfaction-engagement/culture-programs', label: 'Culture & Experience Programs', icon: Sparkles },
      { path: '/employee-satisfaction-engagement/wellbeing-programs', label: 'Wellbeing, Wellness & Support Programs', icon: Coffee },
      { path: '/employee-satisfaction-engagement/self-service-experience', label: 'Self-Service Experience Improvement', icon: MonitorSmartphone },
      { path: '/employee-satisfaction-engagement/career-growth-experience', label: 'Career, Growth & Development Experience', icon: TrendingUp },
      { path: '/employee-satisfaction-engagement/workload-flexibility', label: 'Workload, Flexibility & Work Design', icon: Scale },
      { path: '/employee-satisfaction-engagement/manager-effectiveness', label: 'Manager Effectiveness Improvement', icon: Briefcase },
      { path: '/employee-satisfaction-engagement/community-participation', label: 'Community, Belonging & Participation', icon: Handshake },
      { path: '/employee-satisfaction-engagement/experience-recovery', label: 'Grievance Resolution & Experience Recovery', icon: RefreshCw },
      { path: '/employee-satisfaction-engagement/helpdesk-service-experience', label: 'HR Helpdesk & Service Experience', icon: Headphones },
      { path: '/employee-satisfaction-engagement/governance-approvals', label: 'Engagement Workflow, Governance & Approvals', icon: ClipboardCheck },
    ],
  },
  {
    label: 'Predictive Engagement Intelligence, Risk & Strategic Workforce Experience',
    icon: Brain,
    path: '/employee-satisfaction-engagement/analytics',
    children: [
      { path: '/employee-satisfaction-engagement/analytics', label: 'Engagement Analytics & Dashboards', icon: BarChart3 },
      { path: '/employee-satisfaction-engagement/driver-analysis', label: 'Engagement Driver Analysis', icon: GitBranch },
      { path: '/employee-satisfaction-engagement/burnout-risk', label: 'Burnout & Wellbeing Risk Prediction', icon: Flame },
      { path: '/employee-satisfaction-engagement/engagement-decline', label: 'Engagement Decline Prediction', icon: TrendingDown },
      { path: '/employee-satisfaction-engagement/attrition-linked-risk', label: 'Attrition-linked Engagement Risk', icon: Link2 },
      { path: '/employee-satisfaction-engagement/experience-gap-opportunities', label: 'Experience Gap & Improvement Opportunities', icon: Activity },
      { path: '/employee-satisfaction-engagement/ai-recommendations', label: 'AI Engagement Recommendations', icon: Bot },
      { path: '/employee-satisfaction-engagement/ai-sentiment-intelligence', label: 'AI Sentiment & Feedback Intelligence', icon: Brain },
      { path: '/employee-satisfaction-engagement/forecasting', label: 'Experience Forecasting', icon: LineChart },
      { path: '/employee-satisfaction-engagement/scenario-modeling', label: 'Scenario Modeling & What-if Planning', icon: Telescope },
      { path: '/employee-satisfaction-engagement/strategic-experience-intelligence', label: 'Strategic Workforce Experience Intelligence', icon: Crown },
      { path: '/employee-satisfaction-engagement/executive-decision-support', label: 'Executive Decision Support', icon: Sparkles },
      { path: '/employee-satisfaction-engagement/copilot', label: 'Engagement Copilot (ESE)', icon: Bot },
    ],
  },
];
